import { FirebaseApp, getApps, initializeApp } from 'firebase/app';

import { GetConfigUtil } from '~/shared/utils/envUtil';

const ENV_CONFIG = GetConfigUtil.getPublicStaticConfig();

let app: FirebaseApp;
if (getApps().length === 0) {
  app = initializeApp(ENV_CONFIG.FIREBASE_CONFIG);
} else {
  app = getApps()[0];
}

export { app as firebaseApp };
